import { Autoplay, Keyboard, Navigation } from "swiper";
import { IIndexable } from "../../model/IIndexable";
import { Device } from "@bpba/ui-components";
import { SvgData } from "../../model/SvgData";

export const ConfigSlider: IIndexable = {
  mobile: {
    minForSlider: 4,
    slidesPerView: 3,
    modules: [Keyboard, Autoplay],
    centeredSlides: false,
    loop: false,
    classContainer: "swiper-mobile",
    slides: [],
  },
  tablet: {
    minForSlider: 6,
    slidesPerView: 6,
    modules: [Keyboard],
    centeredSlides: true,
    loop: true,
    classContainer: "swiper-tablet",
    slides: [],
  },
  desktop: {
    minForSlider: 7,
    slidesPerView: 6,
    modules: [Keyboard, Navigation],
    loop: false,
    centeredSlides: false,
    classContainer: "swiper-desktop",
    slides: [],
  },
};

export const getConfig = (device: Device, slides: SvgData[]) => {
  const selectedConfig = ConfigSlider[device];

  selectedConfig.slides = slides;

  return selectedConfig;
};
